"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") {
		for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: () => from[key],
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var OneStackRouter_exports = {};
__export(OneStackRouter_exports, { CustomStackRouter: () => CustomStackRouter });
module.exports = __toCommonJS(OneStackRouter_exports);
var import_native = require("@react-navigation/native");
var CustomStackRouter = function(options) {
	var router = (0, import_native.StackRouter)(options);
	var og = router.getStateForAction.bind(router);
	router.getStateForAction = function(state, action, options2) {
		return og(state, action, options2);
	};
	return router;
};
//# sourceMappingURL=OneStackRouter.js.map
